import React from 'react'
import Card from '../nura/card/card'
import Modal from '../modal/modal'
import Button from '../nura/button/button'
import BaseForm from "../base-form/base-form"

import styles from './styles.module.css'
import { useDispatch, Actions } from '../../stores/dashboard.store'

export default ({ show, setShow, details }) => {
    const dispatch = useDispatch()

    const navigate = (nav) => {        
        setShow(false)
        dispatch(Actions.NavigateDashboard, nav)
    }

    return (
        <Modal show={show} onClose={() => setShow(false)}>
            <Card variant="modal" style={{ width: 358 }}>
                <BaseForm onBack={() => setShow(false)} title={details?.title}>
                    <div className={styles.menuDescription}>
                        <div>{details?.description}</div>
                    </div>                    
                    <div className={styles.actionGroup}>
                        {!!details?.navigation && (
                            <Button style={{ width: '100%' }} variant="outline" onClick={() => navigate(details?.navigation)}>Navigate</Button>
                        ) }
                        <Button style={{ width: '100%' }} variant="error" onClick={() => setShow(false)}>OK</Button>
                    </div>
                </BaseForm>
            </Card>
        </Modal>
    )
}